module.exports = __webpack_public_path__ + "static/media/Italian_traffic_signs_Coda.cd1faa95.svg";